/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ApiService } from '../../../shared/utils/api-servies';
const apiUrl = 'https://squid-app-tpgns.ondigitalocean.app/';
const headers = { 'telegram-data': window.Telegram.WebApp.initData };
export class HistoryApiService {
    constructor() {
        this.apiService = new ApiService(apiUrl, headers);
    }
    async getHistoryCases() {
        return this.apiService.get('case/history', {});
    }
}
